// src/utils/picolApi.js
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase';

const functions = getFunctions(app);
const picolSearchFn = httpsCallable(functions, 'picolSearch');

async function callPicol(type, query) {
  const result = await picolSearchFn({ type, query });
  return deduplicateProducts(result.data);
}

export async function searchByEpa(epaNumber) {
  return callPicol('epa', epaNumber.trim().replace(/\s/g, ''));
}

function deduplicateProducts(data) {
  if (!data) return [];
  const map = new Map();
  for (const item of data) {
    const key = `${item.Id}-${item.Name}`;
    if (!map.has(key)) {
      map.set(key, { ...item, StateRecords: [...(item.StateRecords || [])] });
    } else {
      const existing = map.get(key);
      for (const sr of (item.StateRecords || [])) {
        const alreadyHas = existing.StateRecords.some(
          e => e.StateId === sr.StateId && e.Year === sr.Year
        );
        if (!alreadyHas) existing.StateRecords.push(sr);
      }
    }
  }
  return Array.from(map.values());
}

export function getStateStatus(products) {
  const waProducts = products.filter(p =>
    (p.StateRecords || []).some(sr => sr.StateId === 1)
  );
  const orProducts = products.filter(p =>
    (p.StateRecords || []).some(sr => sr.StateId === 2)
  );

  const waYears = waProducts.flatMap(p =>
    p.StateRecords.filter(sr => sr.StateId === 1).map(sr => sr.Year)
  );
  const orYears = orProducts.flatMap(p =>
    p.StateRecords.filter(sr => sr.StateId === 2).map(sr => sr.Year)
  );

  const maxWaYear = waYears.length ? Math.max(...waYears) : null;
  const maxOrYear = orYears.length ? Math.max(...orYears) : null;
  const currentYear = new Date().getFullYear();

  return {
    washington: {
      registered: waProducts.length > 0,
      current: maxWaYear >= currentYear - 2,
      lastYear: maxWaYear,
      productCount: waProducts.length
    },
    oregon: {
      registered: orProducts.length > 0,
      current: maxOrYear >= currentYear - 2,
      lastYear: maxOrYear,
      productCount: orProducts.length
    }
  };
}